import { useLocation, useNavigate } from "react-router-dom";
import "./manageNavbar.css";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import User from "../../Assets/Images/user.png";
import { setLoggedUser } from "../../Redux/Actions/userActions";
import hasAccess from "../hasAccess";

const ManageNavbar = () => {
  const location = useLocation();

  const [openMenu, setOpenMenu] = useState(false);
  const [openDropdownMenu, setOpenDropdownMenu] = useState(false);

  const loggedUser = useSelector((state) => state.users.loggedUser);

  const isLoggedIn = loggedUser && Object.keys(loggedUser).length > 0;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const menu = [
    {
      title: "Dashboard",
      path: "/manage/dashboard",
      icon: "fa-solid fa-house",
      access: null,
    },
    {
      title: "Aktivitete",
      path: "/manage/aktivitete",
      icon: "fa-regular fa-newspaper",
      access: "aktivitete",
    },
    {
      title: "Video",
      path: "/manage/video",
      icon: "fa-brands fa-youtube",
      access: "video",
    },
    {
      title: "Ekspozita",
      path: "/manage/ekspozita",
      icon: "fa-solid fa-person-chalkboard",
      access: "ekspozita",
    },
    {
      title: "Objekte Muzeale",
      path: "/manage/objekte-muzeale",
      icon: "fa-solid fa-building-columns",
      access: "objekteMuzeale",
    },
    {
      title: "Revista Arkivi Shqiptar",
      path: "/manage/revista",
      icon: "fa-solid fa-newspaper",
      access: "revista",
    },
    {
      title: "Botime te AQSH",
      path: "/manage/botime",
      icon: "fa-solid fa-book",
      access: "botime",
    },
    {
      title: "Rregj. i Dok. RHK",
      path: "/manage/regjistriRhk",
      icon: "fa-solid fa-book-open",
      access: "regjistriRhk",
    },
    {
      title: "Rregj. i Dok. të Humbura",
      path: "/manage/regjistriDokHumbura",
      icon: "fa-solid fa-rectangle-list",
      access: "regjistriDokHumbura",
    },
    {
      title: "Pozicione vakante",
      path: "/manage/pozicione-vakante",
      icon: "fa-solid fa-user-plus",
      access: "pozicioneVakante",
    },
    {
      title: "Rolet",
      path: "/manage/roles",
      icon: "fa-solid fa-user-shield",
      access: "roles",
    },
    {
      title: "Përdoruesit",
      path: "/manage/users",
      icon: "fa-solid fa-users",
      access: "users",
    },
  ];

  const visibleMenu = menu.filter((item) => {
    if (!item.access) {
      return true;
    }

    return hasAccess(loggedUser, item.access);
  });

  const redirect = (path) => {
    navigate(path);
    setOpenMenu(false);
  };

  const toggleDropdown = () => {
    setOpenDropdownMenu((prev) => !prev);
  };

  const handleLogOut = () => {
    dispatch(setLoggedUser({}));

    localStorage.setItem("loggedUser_id", 0);
    localStorage.removeItem("token");

    setOpenDropdownMenu(false);
    setOpenMenu(false);

    navigate("/login");
  };

  const handleUsers = () => {
    navigate("/manage/user");
    setOpenDropdownMenu(false);
  };

  const getPageTitle = () => {
    if (location.pathname.includes("/manage/dashboard")) {
      return "Dashboard";
    }

    if (location.pathname.includes("/manage/aktivitete")) {
      return "Aktivitete";
    }

    if (location.pathname.includes("/manage/video")) {
      return "Video";
    }

    if (location.pathname.includes("/manage/ekspozita")) {
      return "Ekspozita";
    }

    if (location.pathname.includes("/manage/objekte-muzeale")) {
      return "Objekte Muzeale";
    }

    if (location.pathname.includes("/manage/revista")) {
      return "Revista të Arkivit Shqiptar";
    }

    if (location.pathname.includes("/manage/botime")) {
      return "Botime të AQSH";
    }

    if (location.pathname.includes("/manage/regjistriRhk")) {
      return "Rregjistri i Dokumenteve RHK në Pronësi të Privatëve";
    }

    if (location.pathname.includes("/manage/regjistriDokHumbura")) {
      return "Rregjistri i Dokumenteve të Shpallura të Humbura";
    }

    if (location.pathname.includes("/manage/pozicione-vakante")) {
      return "Pozicione Vakante";
    }

    if (location.pathname.includes("/manage/roles")) {
      return "Rolet";
    }

    if (location.pathname.includes("/manage/user")) {
      return "Përdoruesit";
    }

    return "";
  };

  return (
    <div className="manage-navbar">
      <div className="logo-text">{getPageTitle()}</div>

      <div className="manage-navbar-icons">
        <div className="navbar-tab">
          <a href="https://arkiva.gov.al" target="_blank" rel="noreferrer">
            ARKIVA.GOV.AL
          </a>
        </div>
      </div>

      <div className="user-profile">
        <button onClick={toggleDropdown}>
          {loggedUser.firstName} {loggedUser.lastName}
          <img src={User} alt="user" />
        </button>

        {openDropdownMenu && (
          <div className="profile-menu">
            <ul>
              {hasAccess(loggedUser, "user") && (
                <li onClick={handleUsers}>
                  <i className="fa-solid fa-users"></i> Profili
                </li>
              )}

              <li onClick={handleLogOut}>
                <i className="fa-solid fa-right-from-bracket"></i> Log out
              </li>
            </ul>
          </div>
        )}
      </div>

      <div className={`navbar-menu ${openMenu ? "expanded" : "collapsed"}`}>
        <div className="burger-menu" onClick={() => setOpenMenu(!openMenu)}>
          {openMenu ? (
            <i className="fa-solid fa-xmark"></i>
          ) : (
            <i className="fa-solid fa-bars"></i>
          )}
        </div>

        <div className={`menu-tabs ${openMenu ? "expanded" : "collapsed"}`}>
          {visibleMenu.map((item) => (
            <div
              className={`menu-tab ${
                location.pathname.includes(item.path) ? "active" : ""
              }`}
              key={item.path}
              onClick={() => redirect(item.path)}
            >
              <i className={item.icon}></i>
              <span>{item.title}</span>
            </div>
          ))}

          {isLoggedIn ? (
            <div className="menu-tab" onClick={handleLogOut}>
              <i className="fa-solid fa-arrow-right-from-bracket fa-flip-horizontal"></i>
              <span>Logout</span>
            </div>
          ) : (
            <div className="menu-tab" onClick={() => navigate("/login")}>
              <i className="fa-solid fa-right-from-bracket"></i>
              <span>Log in</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManageNavbar;
